import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable @next/next/no-img-element */
import AppLogo from '../AppLogo';
import Link from 'next/link';
import { Popover, Transition } from '@headlessui/react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import { useTranslation } from 'react-i18next';
import { Fragment, useContext } from 'react';
import { UserContext } from '../../hooks/useAuth';
import { classNames } from '@yalendar/shared/ui-core';
import Image from 'next/image';
var navigation = [{
  name: 'landing.navigations.features',
  href: '#features',
  target: '_self'
}, {
  name: 'landing.navigations.pricing',
  href: '#pricing',
  target: '_self'
}, {
  name: 'landing.navigations.faq',
  href: '#faq',
  target: '_self'
}, //{ name: 'landing.navigations.docs', href: 'https://docs.yalendar.com' },
{
  name: 'landing.navigations.blog',
  href: '/blog',
  target: '_blank'
}];
/* eslint-disable-next-line */

export function Navbar(_ref) {
  var appURL = _ref.appURL,
      _ref$hideNavigation = _ref.hideNavigation,
      hideNavigation = _ref$hideNavigation === void 0 ? false : _ref$hideNavigation,
      isVisible = _ref.isVisible;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(UserContext),
      user = _useContext.user,
      isLoading = _useContext.isLoading;

  return /*#__PURE__*/_jsxs(Popover, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "px-4 mx-auto max-w-7xl sm:px-6",
      children: /*#__PURE__*/_jsxs("nav", {
        className: "relative flex items-center justify-between sm:h-10 md:justify-center",
        "aria-label": "Global",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex items-center flex-1 md:absolute md:inset-y-0 md:left-0",
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex items-center justify-between w-full md:w-auto",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-40 lg:w-52",
              children: isVisible ? /*#__PURE__*/_jsx(AppLogo, {
                full: true
              }) : /*#__PURE__*/_jsx(Image, {
                src: "https://kreezus.com/wp-content/uploads/2022/06/1_PNG_2.png",
                alt: "Yalendar",
                layout: "responsive",
                width: 3930,
                height: 916
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "flex items-center -mr-2 md:hidden",
              children: /*#__PURE__*/_jsxs(Popover.Button, {
                className: "inline-flex items-center justify-center p-2 text-gray-400 rounded-md bg-gray-50 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                children: [/*#__PURE__*/_jsx("span", {
                  className: "sr-only",
                  children: t('landing.openMainMenu')
                }), /*#__PURE__*/_jsx(MenuIcon, {
                  className: "w-6 h-6",
                  "aria-hidden": "true"
                })]
              })
            })]
          })
        }), !hideNavigation && /*#__PURE__*/_jsx("div", {
          className: "hidden md:flex md:space-x-4 lg:space-x-6 xl:space-x-8",
          children: navigation.map(function (item) {
            return /*#__PURE__*/_jsx(Link, {
              href: item.href,
              children: /*#__PURE__*/_jsx("a", {
                className: classNames(isVisible ? 'text-gray-500' : 'text-gray-200', 'font-medium duration-700 hover:text-indigo-600 transition-color'),
                target: item.target,
                children: t(item.name)
              })
            }, item.name);
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "hidden space-x-3 md:absolute md:flex md:items-center md:justify-end md:inset-y-0 md:right-0",
          children: [/*#__PURE__*/_jsx("span", {
            className: "hidden rounded-md shadow lg:inline-flex",
            children: /*#__PURE__*/_jsx("a", {
              href: "https://yalendar.com/kreezus/demo-yalendar",
              target: "_blank",
              rel: "noreferrer",
              className: "inline-flex items-center px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700",
              children: t('landing.bookDemoAppointment')
            })
          }), /*#__PURE__*/_jsx("span", {
            className: "inline-flex rounded-md shadow",
            children: /*#__PURE__*/_jsx(Link, {
              href: "".concat(appURL, "/auth/login"),
              children: /*#__PURE__*/_jsx("a", {
                className: classNames('inline-flex items-center px-4 py-2 text-base font-medium text-indigo-600 bg-white border border-transparent rounded-md hover:bg-gray-50', isLoading ? 'flex items-center justify-center' : ''),
                children: user ? t('landing.linkToMyAccount') : isLoading ? /*#__PURE__*/_jsxs("svg", {
                  className: "w-5 h-5 -ml-1 text-purple-500 animate-spin",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  children: [/*#__PURE__*/_jsx("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4"
                  }), /*#__PURE__*/_jsx("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })]
                }) : t('landing.linkToLogin')
              })
            })
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(Transition, {
      as: Fragment,
      enter: "duration-150 ease-out",
      enterFrom: "opacity-0 scale-95",
      enterTo: "opacity-100 scale-100",
      leave: "duration-100 ease-in",
      leaveFrom: "opacity-100 scale-100",
      leaveTo: "opacity-0 scale-95",
      children: /*#__PURE__*/_jsx(Popover.Panel, {
        focus: true,
        className: "absolute inset-x-0 top-0 z-10 p-2 transition origin-top-right transform md:hidden",
        children: /*#__PURE__*/_jsxs("div", {
          className: "overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black ring-opacity-5",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex items-center justify-between px-5 pt-4",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-52",
              children: /*#__PURE__*/_jsx(AppLogo, {
                full: true
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "-mr-2",
              children: /*#__PURE__*/_jsxs(Popover.Button, {
                className: "inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                children: [/*#__PURE__*/_jsx("span", {
                  className: "sr-only",
                  children: t('landing.closeMenu')
                }), /*#__PURE__*/_jsx(XIcon, {
                  className: "w-6 h-6",
                  "aria-hidden": "true"
                })]
              })
            })]
          }), !hideNavigation && /*#__PURE__*/_jsx("div", {
            className: "px-2 pt-2 pb-3",
            children: navigation.map(function (item) {
              return /*#__PURE__*/_jsx(Link, {
                href: item.href,
                children: /*#__PURE__*/_jsx("a", {
                  className: "block px-3 py-2 text-base font-medium text-gray-700 rounded-md hover:text-gray-900 hover:bg-gray-50",
                  target: item.target,
                  children: t(item.name)
                })
              }, item.name);
            })
          }), /*#__PURE__*/_jsx("span", {
            className: "inline-flex w-full my-2",
            children: /*#__PURE__*/_jsx("a", {
              href: "https://yalendar.com/kreezus/demo-yalendar",
              target: "_blank",
              rel: "noreferrer",
              className: "inline-flex items-center justify-center w-full px-4 py-2 mx-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700",
              children: t('landing.bookDemoAppointment')
            })
          }), /*#__PURE__*/_jsx(Link, {
            href: "".concat(appURL, "/auth/login"),
            children: /*#__PURE__*/_jsx("a", {
              className: "block w-full px-5 py-3 font-medium text-center text-indigo-600 bg-gray-50 hover:bg-gray-100",
              children: t('landing.linkToLogin')
            })
          })]
        })
      })
    })]
  });
}
export default Navbar;